export const PUBLISH_BUTTON = {
  PUBLISHING_TEXT: "Publishing...",
  PUBLISH_TEXT: "Publish"
};

export const PUBLISH_BUTTON_TOOLTIP = {
  IN_PROGRESS: "Publish is in progress",
  BUILD_NEEDED: "Please save changes and build to perform this action",
  PUBLISH_FAILED: "Publish failed. Try again after fixing the issue"
};
